/* ==========================================================================
   SpaceHawk survey — completion aids
   Progress, conditional fields, inline validation, and a saved draft.
   Every piece degrades safely: with JS off the form still submits.
   ========================================================================== */
(function () {
  'use strict';

  var form = document.getElementById('sh-survey-form');
  if (!form) return;

  var DRAFT = 'sh-survey-draft';

  /* ---------------------------------------------------------------
     1. Conditional fields — never show a box until it's relevant
     --------------------------------------------------------------- */
  function syncConditionals() {
    document.querySelectorAll('[data-show-when]').forEach(function (el) {
      var sel = el.dataset.showWhen;                 // name|value
      var parts = sel.split('|');
      var checked = form.querySelector('input[name="' + parts[0] + '"]:checked');
      var match = checked && checked.value === parts[1];
      el.hidden = !match;
      el.querySelectorAll('input, textarea, select').forEach(function (i) {
        i.disabled = !match;                          // disabled fields aren't submitted
      });
    });

    document.querySelectorAll('[data-hide-when]').forEach(function (el) {
      var parts = el.dataset.hideWhen.split('|');
      var field = form.querySelector('[name="' + parts[0] + '"]');
      el.hidden = !!(field && field.value === parts[1]);
    });

    // hide while a particular radio is the one selected
    document.querySelectorAll('[data-hide-when-checked]').forEach(function (el) {
      var parts = el.dataset.hideWhenChecked.split('|');
      var checked = form.querySelector('input[name="' + parts[0] + '"]:checked');
      var hide = !checked || checked.value === parts[1];
      el.hidden = hide;
      el.querySelectorAll('input, textarea, select').forEach(function (i) { i.disabled = hide; });
    });
  }

  /* ---------------------------------------------------------------
     3. Inline validation — flag a field when the user leaves it,
        never while they're still typing in it
     --------------------------------------------------------------- */
  form.querySelectorAll('input, textarea, select').forEach(function (field) {
    field.addEventListener('blur', function () {
      if (!field.required) return;
      var bad = !field.checkValidity();
      field.setAttribute('aria-invalid', bad ? 'true' : 'false');
      var msg = field.parentElement.querySelector('[data-msg]');
      if (msg) msg.textContent = bad ? (field.validationMessage || '') : '';
    });
    field.addEventListener('input', function () {
      if (field.getAttribute('aria-invalid') === 'true' && field.checkValidity()) {
        field.setAttribute('aria-invalid', 'false');
        var msg = field.parentElement.querySelector('[data-msg]');
        if (msg) msg.textContent = '';
      }
    });
  });

  /* ---------------------------------------------------------------
     4. Draft — a half-finished survey survives a closed tab
     --------------------------------------------------------------- */
  function saveDraft() {
    try {
      var data = {};
      new FormData(form).forEach(function (v, k) { data[k] = v; });
      localStorage.setItem(DRAFT, JSON.stringify(data));
    } catch (e) { /* private mode or full quota — not worth failing over */ }
  }

  function restoreDraft() {
    try {
      var raw = localStorage.getItem(DRAFT);
      if (!raw) return;
      var data = JSON.parse(raw);
      Object.keys(data).forEach(function (k) {
        var fields = form.querySelectorAll('[name="' + CSS.escape(k) + '"]');
        fields.forEach(function (f) {
          if (f.type === 'radio') { if (f.value === data[k]) f.checked = true; }
          else if (!f.value) { f.value = data[k]; }
        });
      });
      // Shopify's own hidden fields (form_type, utf8) are always present,
      // so count only real answers before claiming we restored anything.
      var answered = Object.keys(data).filter(function (k) {
        return k.indexOf('contact[') === 0 &&
               k !== 'contact[Company]' &&
               String(data[k]).trim() !== '';
      });
      var note = document.getElementById('sh-draft-note');
      if (note && answered.length) note.hidden = false;
    } catch (e) { /* ignore */ }
  }

  var clearBtn = document.getElementById('sh-draft-clear');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      try { localStorage.removeItem(DRAFT); } catch (e) {}
      form.reset();
      syncConditionals();
      document.getElementById('sh-draft-note').hidden = true;
    });
  }

  /* ---------------------------------------------------------------
     5. Submit — stop a double-click creating two emails
     --------------------------------------------------------------- */
  /* ---------------------------------------------------------------
     Email body template
     Shopify's contact-form email isn't editable in Notifications, and
     the subject can't be set. What IS ours is contact[body] — so we
     rewrite it into a readable block just before posting.

     The textarea keeps name="contact[body]", so with JS off the answer
     still arrives; it just isn't formatted.
     --------------------------------------------------------------- */
  function composeBody() {
    var body = form.querySelector('[name="contact[body]"]');
    if (!body) return;

    var get = function (name) {
      var f = form.querySelector('[name="contact[' + name + ']"]:checked') ||
              form.querySelector('[name="contact[' + name + ']"]');
      return f && !f.disabled ? String(f.value).trim() : '';
    };

    var answer = body.value.trim();
    var name = (get('First name') + ' ' + get('Last name')).trim();
    var lines = [];

    lines.push('SPACEHAWK CUSTOMER SURVEY');
    lines.push('----------------------------------------');
    lines.push('');
    if (name) lines.push('Name:        ' + name);
    var email = get('email');
    if (email) lines.push('Email:       ' + email);
    lines.push('');

    var market = get('Marketplace');
    if (market && market !== 'Not yet') {
      lines.push('MARKETPLACE FEEDBACK');
      lines.push('Left on:     ' + market);
      var when = get('Feedback date');
      if (when) lines.push('When:        ' + when);
      var quote = get('Feedback quote');
      if (quote) lines.push('They wrote:  ' + quote);
      lines.push('');
    } else {
      lines.push('MARKETPLACE FEEDBACK');
      lines.push('None left yet.');
      lines.push('');
    }

    lines.push('ONE THING WE COULD DO BETTER');
    lines.push(answer || '(no answer)');
    lines.push('');
    lines.push('----------------------------------------');
    lines.push('Submitted:   ' + new Date().toLocaleString());
    lines.push('From page:   ' + window.location.href);
    lines.push('Reward due within 48 hours.');

    body.value = lines.join('\n');
  }

  form.addEventListener('submit', function () {
    composeBody();
    try { localStorage.removeItem(DRAFT); } catch (e) {}
    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.dataset.label = btn.textContent;
      btn.textContent = 'Sending…';
      // re-enable if the browser blocks the post on a validation error
      setTimeout(function () {
        if (!form.checkValidity()) { btn.disabled = false; btn.textContent = btn.dataset.label; }
      }, 60);
    }
  });

  form.addEventListener('input', function () { saveDraft(); });
  form.addEventListener('change', function () {
    syncConditionals(); saveDraft();
  });

  restoreDraft();
  syncConditionals();

  /* ---------------------------------------------------------------
     Scroll progress
        Shows position on the page, not completion — the form is short
        enough that "how much is left" is the useful signal.
     --------------------------------------------------------------- */
  var bar = document.querySelector('#sh-scroll .shf-scroll__bar');
  if (bar) {
    var ticking = false;
    var paint = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      bar.style.width = Math.min(100, Math.max(0, pct)) + '%';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }, { passive: true });
    window.addEventListener('resize', paint, { passive: true });
    paint();
  }
})();